import {
    getSweetShopArticleCategoryByUid,
    GetSweetShopArticleCategoryByUidApiResponseSchema,
} from './get-sweet-shop-article-category-by-uid';
import {
    getSweetShopArticleCategoryTagsByCategoryUid,
    GetSweetShopArticleCategoryTagsByCategoryUidApiResponseSchema,
} from './get-sweet-shop-article-category-tags-by-category-uid';
import {
    getSweetShopArticlesByCategoryUidAndTagUid,
    GetSweetShopArticlesByCategoryUidAndTagUidApiResponseSchema,
} from './get-sweet-shop-articles-by-category-uid-and-tag-uid';

export {
    GetSweetShopArticleCategoryByUidApiResponseSchema,
    GetSweetShopArticleCategoryTagsByCategoryUidApiResponseSchema,
    GetSweetShopArticlesByCategoryUidAndTagUidApiResponseSchema,
};

export const SweetShopArticlesPageActions = {
    getSweetShopArticleCategoryByUid,
    getSweetShopArticleCategoryTagsByCategoryUid,
    getSweetShopArticlesByCategoryUidAndTagUid,
};
